<template>
  <div class="create-content">
    <div class="iamge">
      <img src="../../assets/sdk/record_mode_1.gif" alt="" />
      <img src="../../assets//sdk//record_mode_2.gif" alt="" />
    </div>
    <p>点击下方按钮添加方案</p>
  </div>
</template>
<script setup>

</script>
<style scoped>
.create-content {
  height: 100vh;
  width: 100vw;
  background-color: #283138;
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
}
.iamge {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 42px;
  padding: 0 16px;
}

.iamge img {
  width: 45vw;
  border-radius: 30px;
}
p {
  color: #fff;
  font-size: 28px;
  text-align: center;
}
</style>
